export enum ProductProposalsBrandStateEnum {
    FILLED = 'filled',
    EXISTS = 'exists',
    NOT_EXISTS = 'not_exists',
}
